var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isVisible)?_c('div',{staticClass:"popup-overlay"},[_c('div',{staticClass:"popup-content"},[_c('div',{staticClass:"print-header"},[_c('button',{staticClass:"modal-close-btn",attrs:{"aria-label":"Close"},on:{"click":_vm.closePopup}},[_vm._v("✕")])]),_vm._v(" "),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }